import Homepage from "../components/Homepage";

export default [
    { path: "/", component: Homepage },
];
